<template>
  <router-view :key="'itemgroups_' + $route.path" />
</template>
<script>
export default {
  mounted() {
    this.$store.state.breadcrumbs = {
      title: "Informatie",
      links: [
        {
          title: "Informatie",
          href: "/itemgroups",
        },
      ],
    };

    if (this.$route.meta.Breadcrumb) {
      this.$store.commit("addBreadcrumb", {
        title: this.$route.meta.Breadcrumb,
        href: this.$route.path,
      });
    }
  },
  created() {
    this.$store.state.inner_sidebar_loader = true;

    this.$store.state.inner_sidebar = this.$store.state.inner_sidebar_backup[
      "informations"
    ];
    this.$store
      .dispatch("get", "api/v1/itemgroups/parent_id/1")
      .then((data) => {
        console.log(data);
        var temp = data.data.map((itemgroup) => {
          return {
            title: itemgroup.title,
            href: "/itemgroups/" + itemgroup.id + "/" + itemgroup.title_slug,
            children: itemgroup.children.map((child) => {
              return {
                title: child.title,
                href: "/itemgroups/" + child.id + "/" + child.title_slug,
                children: [],
              };
            }),
          };
        });

        this.$store.state.inner_sidebar = [...temp];
        this.$store.state.inner_sidebar_backup["informations"] = [...temp];
        this.$store.state.inner_sidebar_loader = false;
      })
      .catch((error) => {
        console.log(error);
        this.$store.state.inner_sidebar_loader = false;
      });
  },
};
</script>
